module.exports = __webpack_public_path__ + "static/media/guadalupe_celio.91812c9a.png";